import classNames from 'classnames'

export interface ExcerptProps extends React.ComponentPropsWithoutRef<'p'> {}

export interface ExcerptTextProps
  extends React.ComponentPropsWithoutRef<'span'> {}

export const ExcerptText = ({
  children,
  className,
  ...props
}: ExcerptTextProps) => {
  return (
    <span className={className} {...props}>
      {children}
    </span>
  )
}

export const Excerpt = ({ children, className, ...props }: ExcerptProps) => {
  return (
    <p className={classNames('content-teaser__excerpt', className)} {...props}>
      {children}
    </p>
  )
}
